export const habaWishlist = {
  wishlistOverview: {
    title: 'Meine Listen',
    addNew: 'Neue Merkliste erstellen',
    noWishlists: 'Sie haben keine Listen',
    underConstruction: {
      headline: '“Meine Merkliste” ist bald wieder verfügbar!',
      subHeadline:
        'Aufgrund einer Systemanpassung steht diese Funktion derzeit leider nicht zur Verfügung.',
      list1: 'Nutze vorübergehend deinen Warenkorb, um deine Lieblingsprodukte zu speichern ',
      list2:
        'Du kannst dich gerne zum Newsletter anmelden, um sofort über Neuigkeiten informiert zu werden',
      list3: 'Oder entdecke unsere Neuheiten',
      buttonText: 'Unsere Neuheiten entdecken',
    },
  },
  wishlistCreate: {
    placeholder: 'Merklistennamen eingeben',
    button: 'Neue Merkliste speichern',
    successMessage: 'Merkliste erstellt',
    errorLengthMin: 'Name muss länger als drei Buchstaben sein.',
    errorLengthMax: 'Name muss kürzer als 100 Buchstaben sein',
    errorExitsAlready: 'Name existiert bereits.',
    emptiedListSuccessMessage: 'Ihre Produkte wurden dem Warenkorb hinzugefügt',
    listCreated: 'Merkliste erstellt',
    addNew: 'Merkliste erstellen',
    title: 'Liste erstellen',
  },
  wishlistEdit: {
    edit: 'Liste bearbeiten',
    rename: 'Liste umbenennen',
    delete: 'Liste löschen',
    successMessage: 'Liste bearbeitet',
    questionDelete: 'Möchten Sie die Merkliste und alle enthaltenen Produkte wirklich löschen?',
  },
  wishlistList: {
    noItems: 'Keine Einträge in dieser Liste vorhanden',
    allToBasket: 'Alle Artikel in den Warenkorb',
    deleteWishlist: 'Diese Merkliste löschen',
    removedSuccessMessage: 'Liste entfernt',
    itemRemovedSuccessMessage: 'Liste aktualisiert',
    deletedList: 'Ihre Merkliste wurde gelöscht',
  },
  wishlistMove: {
    title: 'Produkt verschieben',
    subtitle: 'Wählen Sie eine Merkliste aus:',
    successMessage: 'Ihr Produkt wurde verschoben',
    warningCartsMessage: 'Sie haben nur 1 Liste',
  },
  wishlistAdd: {
    addToWishlist: 'Zur Merkliste hinzufügen',
    addToWishlistTitle: 'Zur Merkliste hinzufügen',
    addToCartSuccess: 'Ihr Produkt wurde dem Warenkorb hinzugefügt',
    warningSelectWishlist: 'Sie müssen zuerst eine Liste auswählen',
    title: 'Bitte Liste auswählen',
    noListsCreatedMessage:
      'Du hast noch keine Merkliste erstellt. <br> Klicke unten um eine neue Merkliste zu erstellen.',
    createWishlistAltText: 'oder erstellen Sie eine neue Liste',
    addedToWishlist: 'Zur Liste hinzugefügt',
    addToWishlistLink: 'Auf die Merkliste',
    addedToWishlistNoticed: 'Gemerkt',
    addInWishlist: 'Zur Wunschliste hinzufügen',
    removeFromWishlist: 'Von der Wunschliste entfernen',
  },
  wishlistRemove: {
    main: {
      title: 'Was möchtest du tun?',
      addToWishlist: 'ZU ANDERER LISTE HINZUFÜGEN',
    },
    secondary: {
      title: 'Von welcher Liste soll der Artikel gelöscht werden?',
    },
    removeFromWishlist: 'VON MERKLISTE LÖSCHEN',
  },
};
